<script setup lang="ts">
defineProps({
    text: {
        type: String,
        required: true
    }
});
</script>

<template>
    <button
        type="button"
        class="inline-flex items-center rounded-sm border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-0 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-30"
    >
        {{ text }}
    </button>
</template>
